// extracted by css-extract-rspack-plugin
export default {"root":"HweJWg","no-wrap":"yr5Cro","noWrap":"yr5Cro","excerpt":"P3xNPZ"};